<template>
  <v-card outlined :loading="loading">
    <v-row  style="max-height:226px;" IMAGE DIV>
      <v-col cols="12" class="pa-0 ma-0">
        <div style="text-align:center;cursor:pointer;">
          <v-chip 
            color="primary" 
            small
            :class="`white--text soldout elevation-12 ${arabic?'arFont':'enFont'}`" 
            :style="`${arabic ? 'direction:rtl;left:10px;top:10px;' : 'right:10px;top:10px;'} text-transform:uppercase;z-index: 2;`"
            v-if="true || product.count"
            label>
            {{product.count}} {{ i18n["piece"] }}
          </v-chip>
          
          <v-chip 
            color="#ff9800" 
            small
            :class="`white--text soldout elevation-12 ${arabic?'arFont':'enFont'}`" 
            :style="`${arabic ? 'direction:rtl;right:10px;top:10px;' : 'left:10px;top:10px;'} text-transform:uppercase;z-index: 2;`"
            v-if="product.flash_item">
            {{  i18n["limited_offer"] }}
          </v-chip>
          <v-chip 
            color="primary" 
            small
            :class="`white--text soldout elevation-12 ${arabic ? 'arFont' : 'enFont'}`" 
            :style="`${arabic ? 'direction:rtl;left:10px;bottom:10px;' : 'right:10px;bottom:10px;'} text-transform:uppercase;z-index: 2;`"
            v-if="product.remaining_leads"
            label>
            {{ product.remaining_leads }} {{ i18n["remaining_leads"] }}
          </v-chip>
          <v-chip 
            color="secondary" 
            small
            :class="`white--text soldout elevation-12 ${arabic?'arFont':'enFont'}`" 
            :style="`${arabic ? 'direction:rtl;left:10px;top:37px;' : 'right:10px;top:37px;'} text-transform:uppercase;z-index: 2;`"
            label>
            {{product.sku}}
          </v-chip>
          <img
            v-if="!lazyLoad && product.image && product.image.url"
            :src="product.image.url"
            style="max-height:226px;max-width:100%;"
            @click="openLink(`/product/${cc}/${product.hash}`)"
          >
          <AppImg
            v-if="lazyLoad && product.image && product.image.url"
            :src="`/placeholder.jpg`"
            :lazy-src="product.image.url"
            :lazy-srcset="product.image.url"
            @click="openLink(`/product/${cc}/${product.hash}`)"
          />
          <ImagesSlider
            v-if="product && product.images && product.images.length > 1 && false"
            :product="product"
          />
        </div>
      </v-col>
    </v-row>
    <v-row  px-3 QUANTITY AND COUNTER :class="`${arabic?'arFont':'enFont'} align-center align-content-center`" style="min-height:53px;"   
      v-if="false">
      <v-col v-if="product.quantity > 3" col="2">
        <span style="font-size: 11px;" :class="`${arabic?'arFont':'enFont'}`">{{ i18n.quantity }}</span>
      </v-col>
      <v-col v-if="product.quantity > 3" cols="8" >
        <v-progress-linear class="progressCustom" color="error" rounded :value="product.percentage">
        </v-progress-linear>
      </v-col>
      <v-col v-if="product.quantity > 3 " col="2" px-1>
        <span style="font-size: 11px;">
          {{product.quantity}}
        </span>
      </v-col>
      <v-col v-if="product.quantity <=3 " cols="12" px-1>
        <v-chip 
          color="error" 
          :class="`${arabic?'arFont':'enFont'} white--text`"
          small>{{getQuantityText(product.quantity)}}</v-chip>
      </v-col>
      <v-col cols="4" sm4 v-if="false">
        <span style="font-size: 11px;" :class="`${arabic?'arFont':'enFont'}`">{{ i18n.time_left }}</span>
      </v-col>
      <v-col cols="8" sm8 v-if="false">
        <span style="font-size: 14px;font-weight:600;text-align:center;" class="text-center error--text">
          <countdown :time="product.time * 1000" @end="timeUp(i)" :transform="transform">
            <template slot-scope="props">{{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}</template>
          </countdown>
        </span>
      </v-col>
    </v-row>
    <v-card-title primary-title :class="`${arabic?'arFont':'enFont'} pa-0 ma-0`" :style="`min-height:110px; ${arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`" NAME AND PRICE >
      <v-row class="pa-2">
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0`" >
          <div :class="`${arabic?'arFont':'enFont'} accent--text`" :style="`${arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'} cursor:pointer;font-size:16px;line-height:20px;white-space:pre-wrap; word-break:break-word;`" @click="openLink(`/product/${cc}/${product.hash}`)">
            {{ product['name_' + language].trim() }} 
            
          </div>
        </v-col>
        <v-col cols="6" :class="`${arabic?'arFont':'enFont'} py-0`" :style="`${arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`" v-if="!product.subvendor">
          <div  
            :class="`${arabic?'arFont':'enFont'}`"
            :style="`text-transform:uppercase;font-size:12px; {arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`">
            {{i18n.price}}
          </div>
          <div class="title warning--text">
            {{ product.price.toFixed(1) }}  
            <span 
              :class="`${arabic?'arFont':'enFont'}`"
              :style="`font-size: 11px; {arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`">
              {{currency_symbol}}
            </span>
          </div>
        </v-col>
        <v-col cols="6" :class="`${arabic?'arFont':'enFont'} py-0`" :style="`${arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`" v-if="!product.subvendor">
          <div  
            :class="`${arabic?'arFont':'enFont'}`"
            :style="`text-transform:uppercase;font-size:12px;{arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`">
            {{  i18n["net_profit"] }}
          </div>
          <div class="headline success--text">
            {{ product.user_profit.toFixed(1) }}  
            <span 
              :class="`${arabic?'arFont':'enFont'}`"
              :style="`font-size: 11px;{arabic ? 'text-align:right;direction:rtl;' : 'text-align:left;direction:ltr;'}`">
              {{currency_symbol}}
            </span>
          </div>
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 text-center`" style="font-size:11px;" v-if="product.flash_item">
          {{ product.delayed_flash ?
            i18n["offer_starts_in"]
            : i18n["left_to_offer_end"]
          }}
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 text-center`" v-if="product.flash_item">
          <countdown :time="product.delayed_flash ? product.start_remaining : product.end_remaining">
            <template slot-scope="props">
              <v-progress-circular size="40" :value="props.days" :color="`${product.delayed_flash ? 'success' : 'error'}`">
              <span style="font-size:9px;line-height:9px;" class="text-center">
                {{props.days}}<br/>
                {{  i18n["day"] }}
                </span>
              </v-progress-circular>
              <v-progress-circular size="40" :value="props.hours" :color="`${product.delayed_flash ? 'success' : 'error'}`">
              <span style="font-size:9px;line-height:9px;" class="text-center">
                {{props.hours}}<br/>
                {{ i18n["hour"] }}
                </span>
              </v-progress-circular>
              <v-progress-circular size="40" :value="props.minutes" :color="`${product.delayed_flash ? 'success' : 'error'}`">
              <span style="font-size:9px;line-height:9px;" class="text-center">
                {{props.minutes}}<br/>
                {{ i18n['minutes'] }}
                </span>
              </v-progress-circular>
              <v-progress-circular size="40" :value="props.seconds" :color="`${product.delayed_flash ? 'success' : 'error'}`">
              <span style="font-size:9px;line-height:9px;" class="text-center">
                {{props.seconds}}<br/>
                {{ i18n["second"] }}
                </span>
              </v-progress-circular>
            </template>
          </countdown>
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 text-center`" v-if="product.flash_item && !product.delayed_flash">
          <div :class="`${arabic?'arFont':'enFont'} py-0 mt-1 text-right`" :style="`font-size: 11px;white-space:pre-wrap;line-height: 13px;word-break:break-word;`">
            {{ i18n["left"] }} {{product.count}} {{ i18n["piece"] }}
          </div>
          <v-progress-linear :value="product.count/(product.count*1.3)*100" color="#ff9800" background-color="grey"></v-progress-linear>
          <div :class="`${arabic?'arFont':'enFont'} py-0 mt-1 text-center`" :style="`font-size: 11px;white-space:pre-wrap;line-height: 13px;word-break:break-word;`">{{ i18n["limited_quantity"] }}</div>
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 mt-2 text-center`" :style="`color:#ff9800;font-size: 11px;white-space:pre-wrap;line-height: 13px;word-break:break-word;`" v-if="product.flash_item && !product.delayed_flash">
          {{ i18n["limited_offer_price_will_be_back_to"] }} {{ product.before_flash_price.toFixed(1) }} <span 
              :class="`${arabic?'arFont':'enFont'}`"
              :style="`font-size: 11px;`">
              {{currency_symbol}}
            </span>
            {{ i18n["after"] }} {{product.remaining_hours.toFixed(1)}} {{ i18n["hour"] }}
        </v-col>
        <v-col cols="12" :class="`${arabic?'arFont':'enFont'} py-0 mt-2 text-center success--text`" :style="`font-size: 11px;white-space:pre-wrap;line-height: 15px;word-break:break-word;`" v-if="product.flash_item && product.delayed_flash">
          {{ i18n["this_product_price_will_go_down_to"] }} {{ product.flash_price.toFixed(1) }} <span 
              :class="`${arabic?'arFont':'enFont'}`"
              :style="`font-size: 11px;`">
              {{currency_symbol}}
            </span>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-actions BTNS class="py-0" v-if="!product.subvendor">
      <v-spacer></v-spacer>
      <v-row class="py-0">
        <v-col cols="8" class="px-1">
          <v-btn color="success" depressed v-if="product.flash_item && product.delayed_flash"
            :class="`${arabic?'arFont':'enFont'} pl-5`"
            @click="openLink(`/product/${cc}/${product.hash}`)"
            >
              <v-icon 
                :right="language == 'en'"
                :left="language == 'ar'"
                size="12"
                class="ml-0 pl-0"
              >sell</v-icon>
                {{ i18n["next_flash_sale"] }}
          </v-btn>
          <v-btn class="faddtocart" color="accent" depressed v-else
            :class="`${arabic?'arFont':'enFont'}`"
            @click="addToCart(product)"
            :disabled="cart.map(x=>x.sku).includes(product.sku)"
            >
              <v-icon 
                :right="language == 'en'"
                :left="language == 'ar'"
              >shopping_cart</v-icon>
              <span v-if="!cart.map(x=>x.sku).includes(product.sku)">
                {{ i18n["add_to_cart"] }}
              </span> 
              <span v-if="cart.map(x=>x.sku).includes(product.sku)">
                {{ i18n.added_to_cart }}
              </span> 
          </v-btn>
        </v-col>
        <v-col cols="4" class="text-center px-1">
          <v-btn v-if="!product.fav" icon color="accent" @click="addToFav(product.id)" :class="`${arabic?'arFont':'enFont'}`">
            <v-icon>favorite_border</v-icon>
          </v-btn>
          <v-btn v-if="product.fav" icon color="error" @click="rmvFav(product.id)" :class="`${arabic?'arFont':'enFont'}`">
            <v-icon>favorite</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import AppImg from './imgPlaceholder';
import ImagesSlider from './ImagesSlider';
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

import {firebase, db, auth} from '@/fb';
import axios from 'axios';
let apiBase = 'https://us-central1-ashyaatcrm.cloudfunctions.net/main'
const headers = {'Accept': 'application/json'};

export default {
  components:{ AppImg, ImagesSlider },
  props:["product", "i", 'loading'],
  data(){
    return {
      lazyLoad:false
    }
  },
  methods: {
    getRand(min, max) {
      return getRandomInt(min, max)
    },
    openLink(path) {
      console.log(window.location.protocol + '//' + window.location.host + path)
      window.open(window.location.protocol + '//' + window.location.host + path, '_blank').focus();
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    openCart(){
      this.$store.dispatch('openCart')
    },
    addToCart(product) {
      this.$store.dispatch('addToCart', product)
      if(typeof ttq !== 'undefined') {
        ttq.track('AddToCart')
      }
      if(typeof snaptr !== 'undefined') {
          snaptr('track', 'ADD_CART');
      }
      if(typeof fbq !== 'undefined') {
        fbq('track', 'AddToCart');
      }
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        const word = value < 2 ? key.replace(/s$/, '') : key;
        props[key] = `${digits}`;
      });
      return props;
    },
    getQuantityText(q){
      let qq = {
        en:{
          1:`Only One piece left`,
          2:`Only Two pieces left`,
          3:`Only Three pieces left`,
        },
        ar:{
          1:`بقي قطعة واحدة فقط`,
          2:`بقي قطعتين فقط`,
          3:`بقي ثلاث قطع فقط`,
        },
      }
      return qq[this.language][q]
    },
    timeUp(i){
      this.$store.state.products.splice(i, 1)
    },
    async addToFav(id){
      let a = await this.$store.dispatch('getResource', {resource:`/bayaa-fav/${id}`})
      this.$emit('reload')
    },
    async rmvFav(id){
      let a = await this.$store.dispatch('deleteResource', {resource:`/favs/${id}`})
      this.$emit('reload')
    },
  },
  watch:{
  },
  computed:{
    cc(){
      return this.$store.state.country.alpha2Code
    },
    cart(){
      return this.$store.state.cart
    },
    currency_symbol(){
      return this.$store.state.currency_symbol
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style scoped>
.soldout {
  position: absolute;
}
</style>
